import React from "react"
import { useFormikContext } from "formik"
import MyEditorField from "@common-utils/fields/MyEditorField"
import MyFileField from "@common-utils/fields/MyFileField"
import MyCheckboxFormField from "@common-components/fields/MyCheckboxFormField"
import MySelectGetAllDataFromServer from "@common-utils/fields/MySelectGetAllDataFromServer"
import MyLoadingOverlay from "@common-components/MyLoadingOverlay"
import { CONST_API_UTILS_GET_CLIENTS_ENDPOINT } from "../../../../../../endpoints"
import { IFormValuesModel } from "./LogicQualif"

interface IProps {
     isFetchingContent: boolean
     forceEditorToRefreshContent?: { value: string; random: string }
}

const EntretienQualifFormFields: React.FC<IProps> = ({ isFetchingContent, forceEditorToRefreshContent }) => {
     const formikProps = useFormikContext<IFormValuesModel>()
     const { values, setFieldValue, errors } = formikProps

     return (
          <>
               {/* Notes Section */}
               <div className="mb-5">
                    <label className="col-form-label fw-bold fs-6">Notes</label>
                    <MyLoadingOverlay isActive={isFetchingContent}>
                         <MyEditorField
                              value={values.notes}
                              height={250}
                              onChange={val => setFieldValue("notes", val)}
                              placeholder={"Saisissez vos notes d'entretien..."}
                              forceEditorToRefreshContent={forceEditorToRefreshContent}
                         />
                    </MyLoadingOverlay>
                    {errors.notes && <div className="text-danger mt-1">{errors.notes}</div>}
               </div>

               {/* Client Section (Specific to Qualif) */}
               <div className="mb-5">
                    <label className="col-form-label fw-bold fs-6 required">Client concerné</label>
                    <MySelectGetAllDataFromServer
                         name={"client"}
                         value={values.client}
                         onChange={val => setFieldValue("client", val)}
                         url={CONST_API_UTILS_GET_CLIENTS_ENDPOINT}
                         isInvalid={!!errors.client}
                         placeholder="Rechercher un client..."
                    />
                    {errors.client && <div className="text-danger mt-1">{errors.client}</div>}
               </div>

               {/* Document Attachment */}
               <MyCheckboxFormField
                    label="Pièce jointe"
                    name="voulezVousJoindreUnDocumentToThisSuivi"
                    text="Joindre un document à ce suivi"
                    formikProps={formikProps}
                    classNameLayout={values.voulezVousJoindreUnDocumentToThisSuivi ? "mb-2" : "mb-5"}
                    classNameLabel="col-lg-4"
                    classNameField="col-lg-8"
               />

               {/* File Input */}
               {values.voulezVousJoindreUnDocumentToThisSuivi && (
                    <div className="row mb-5">
                         <div className="col-lg-8 offset-lg-4">
                              <div className="p-3 bg-light border border-dashed rounded">
                                   <MyFileField name={"document"} isInvalid={!!errors.document} onChange={val => setFieldValue("document", val)} />
                                   {errors.document && <div className="text-danger mt-1">{errors.document}</div>}
                              </div>
                         </div>
                    </div>
               )}
          </>
     )
}

export default EntretienQualifFormFields
